import { useMemo } from 'react';
import useRequest from '@gp/hooks/useRequest';
import { fetchClassifiedOrganizations } from '@user-center/services/common';
import { formatPermissionOptions } from '@user-center/pages/ContentManagementCenter/Reports/utils';

import type { CascaderOption } from 'tea-component';

export default function useReportOptions(locale: string) {
  const { loading: permissionOptionsLoading, data: permissionOptionsRes } = useRequest<any, any>(
    fetchClassifiedOrganizations,
  );

  const permissionOptions = useMemo<CascaderOption[]>(() => {
    return formatPermissionOptions(locale, permissionOptionsRes?.data);
  }, [locale, permissionOptionsRes]);

  return { permissionOptionsLoading, permissionOptions };
}
